import { MembershipLayout } from '@layouts/membership/MembershipLayout'
import EventsPage from '@pages/membership/EventsPage'
import { Navigate, RouteObject } from 'react-router-dom'
import eventDetailRoutes from './EventDetailRoutes'

const eventRoutes: RouteObject[] = [
  {
    element: <MembershipLayout />,
    children: [
      { path: 'list', element: <EventsPage /> },
      { index: true, element: <Navigate to="list" replace /> },
      { path: '*', element: <Navigate to="list" replace /> },
    ],
  },
  {
    path: ':eventId',
    children: eventDetailRoutes,
  },
]

export default eventRoutes
